import Routes from './routes/Routes';

export default function App() {
  return (
    <div>
      <Routes />
    </div>
  );
}
